module.exports = __webpack_public_path__ + "img/aliran_dan_volume_fluida.a1a2c896.svg";